// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/icons/transcripts_calendar.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*#region Angular Overrides*/

md-datepicker .md-button.md-icon-button {
  margin: 0 6px;
  padding: 8px;
  width: 40px;
  height: 40px;
  min-width: 0;
  line-height: 24px;
  border-radius: 50%;
}

md-datepicker .md-datepicker-expand-triangle {
  left: 40%;
}

/** Transcript select date range search filter (NOT DATE RANGE ON MODAL) **/
/* styling/layout for box that contains the select date range stuff */
.datePickerHolder {
  margin-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 5px;
}

.datePickerHolder .datePickerHolderInner {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

/* Styling for select text */
.datePickerHolder .selectText {
  font-size: 16px;
  font-weight: bold;
  margin-right: 4rem;
}

/* Make the original bootstrap calendar icon/button transparent */
.datePickerHolder .datePicker .md-datepicker-calendar-icon {
  fill: rgba(0, 0, 0, 0);
}

/* Show a custom calendar icon and position it over the original bootstrap
 * calendar icon */
/* Make it so we can position the .calendarIcon absolutely */
.datePickerHolder .datePicker {
  position: relative;
}

.datePickerHolder .datePicker .label {
  color: #000;
  display: inline-block;
  font-size: 1.2rem;
  position: relative;
}

.datePickerHolder .datePicker .md-datepicker-button.md-button.md-icon-button {
  background: none;
  display: none;
  margin: 0;
  padding-bottom: 16px;
}
/* Put the calendar icon over the original datepicker button */
.datePickerHolder .datePicker .calendarIcon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 2rem;
  height: 2rem;
  background-size: contain;
  display: inline-block;
  position: relative;
  top: 5px;
}

/* Style the border, width/height/padding on the datepicker box */
.datePickerHolder .datePicker .md-datepicker-input-container {
  border: 1px solid #808080;
  width: 18rem;
  padding-bottom: 0px;
}

.datePickerHolder
  .datePicker
  .md-datepicker-open
  .md-datepicker-input-container {
  border: none;
}

.datePickerHolder .datePicker .md-datepicker-input {
  /* Make the 'Completed Before' / 'Completed After' text in the
     * containers not get chopped off */
  min-width: 150px;

  padding-left: 5px;
  padding-top: 3px;
  color: #7f7f7f;
}
/* color the default text in the datepicker boxes */
.datePickerHolder .datePicker .md-datepicker-input::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #7f7f7f;
}
.datePickerHolder .datePicker .md-datepicker-input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #7f7f7f;
  opacity: 1;
}
.datePickerHolder .datePicker .md-datepicker-input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #7f7f7f;
  opacity: 1;
}
.datePickerHolder .datePicker .md-datepicker-input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #7f7f7f;
}

/* Make the triangle on the right hand side of the datepicker box larger */
.datePickerHolder .datePicker .md-datepicker-expand-triangle {
  left: 20%;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 9px solid #b6b6b6;
}

/* Make the datepicker box close to the calendar icon */
.datePickerHolder .md-datepicker-input-container {
  margin-left: 0;
}

.moment-picker .decade-view td,
.moment-picker .year-view td {
  min-height: 8.4em;
  min-width: 6.4285714286em;
}

.moment-picker .month-view td {
  min-width: 3.4285714286em;
}
.moment-picker .day-view td,
.moment-picker .hour-view td {
  min-height: 2.3333333333em;
  min-width: 3.4285714286em;
}
.moment-picker .minute-view td {
  min-height: 1.8em;
}

.moment-picker .moment-picker-container {
  min-width: 15em;
  min-height: 15em;
}

.moment-picker th,
.moment-picker td {
  min-width: 4em;
  min-height: 4em;
}

.moment-picker-input {
  height: 30px;
  min-width: 130px !important;
  text-align: left;
  font-size: 12px;
  padding: 5px !important;
}
.moment-picker.inline {
  position: absolute !important;
}

/*#endregion Angular Overrides*/

/*#region CustomDatePicker*/
.react-datepicker {
  font:
    normal 14px Calibri,
    sans-serif;
  border: 0.5px solid lightgray;
  border-radius: 4px;
}

.react-datepicker-popper {
  z-index: 300;
}

.react-datepicker-wrapper {
  input {
    font:
      normal 14px Calibri,
      sans-serif;
    height: 27px;
    border-radius: 4px;
    border: 1px solid lightgray;
    text-indent: 5px;

    &.add-transcript-modal {
      height: 36px;
      width: 100%;
      border: 0.5px solid black;
    }
  }
  &.add-transcript-modal {
    width: 100%;
  }
}

.react-datepicker-wrapper,
.add-transcript-modal {
  > .react-datepicker__input-container {
    width: 100%;
  }
}

.react-datepicker__navigation-icon::before {
  border: none;
  position: relative;
}

.react-datepicker__navigation-icon {
  width: 50px;
  height: 25px;
  top: -10px;
}

.react-datepicker-popper {
  margin-top: 3px;
}

.react-datepicker__header {
  button {
    border: none;
    background-color: transparent;
    font:
      bold 14px Calibri,
      sans-serif;
    cursor: pointer;
  }
}

.react-datepicker__header--custom {
  background-color: transparent;
  border: none;
  padding-bottom: 0px;
}

.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle {
  fill: white;
  color: white;
  stroke: lightgray;
}

.react-datepicker__day-names {
  font-weight: bold;
  margin-top: 7px;

  .react-datepicker__day-name {
    width: 45px;
    height: 25px;
    margin: 0px;
  }
}

.react-datepicker__day {
  width: 45px;
  height: 25px;
  margin: 0px;
  line-height: 25px;

  &.react-datepicker__day--outside-month {
    color: grey;
  }
}

.react-datepicker__month {
  margin: 5px 0px 5px 0px;
}

.custom-header {
  display: flex;
  padding-left: 10px;
  padding-right: 10px;
  align-items: center;
  margin-bottom: 1px;

  & button {
    display: flex;
    justify-content: center;
    align-content: center;
  }

  .monthYear {
    margin-bottom: 2px;
    min-width: 17px;
  }
}

.react-datepicker__year-wrapper {
  justify-content: center;
}
.react-datepicker__year {
  margin: 0px;
  margin-bottom: 5px;
  margin-top: -5px;
}

.react-datepicker__year .react-datepicker__year-text {
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.react-datepicker__month .react-datepicker__month-text {
  height: 25px;
  line-height: 25px;
}

.calendar-icon {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #e3e3e3;
  width: 34px;
  height: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0px 4px 4px 0px;
  border: 1px solid lightgray;
  pointer-events: none;

  &.add-transcript-modal {
    height: 36px;
    width: 43px;
    border: 0.5px solid black;
  }

  svg {
    width: 16px;
    height: 16px;
    fill: #525354;

    &.add-transcript-modal {
      height: 20px;
      width: 20px;
    }
  }
}

/*#endregion CustomDatePicker*/
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/datepicker.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA,2EAA2E;AAC3E,qEAAqE;AACrE;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,iEAAiE;AACjE;EACE,sBAAsB;AACxB;;AAEA;kBACkB;AAClB,4DAA4D;AAC5D;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;AACA,8DAA8D;AAC9D;EACE,mDAAqE;EACrE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;AACV;;AAEA,iEAAiE;AACjE;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE;uCACqC;EACrC,gBAAgB;;EAEhB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA,mDAAmD;AACnD;EACE,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,cAAc;EACd,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,cAAc;EACd,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;EACE,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA,uDAAuD;AACvD;EACE,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;;EAEE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,6BAA6B;AAC/B;;AAEA,+BAA+B;;AAE/B,2BAA2B;AAC3B;EACE;;cAEY;EACZ,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE;;gBAEY;IACZ,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;;IAEhB;MACE,YAAY;MACZ,WAAW;MACX,yBAAyB;IAC3B;EACF;EACA;IACE,WAAW;EACb;AACF;;AAEA;;EAEE;IACE,WAAW;EACb;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,YAAY;IACZ,6BAA6B;IAC7B;;gBAEY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;;EAEf;IACE,WAAW;IACX,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,iBAAiB;;EAEjB;IACE,WAAW;EACb;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;;EAElB;IACE,aAAa;IACb,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,oBAAoB;;EAEpB;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;;IAEb;MACE,YAAY;MACZ,WAAW;IACb;EACF;AACF;;AAEA,8BAA8B","sourcesContent":["/*#region Angular Overrides*/\n\nmd-datepicker .md-button.md-icon-button {\n  margin: 0 6px;\n  padding: 8px;\n  width: 40px;\n  height: 40px;\n  min-width: 0;\n  line-height: 24px;\n  border-radius: 50%;\n}\n\nmd-datepicker .md-datepicker-expand-triangle {\n  left: 40%;\n}\n\n/** Transcript select date range search filter (NOT DATE RANGE ON MODAL) **/\n/* styling/layout for box that contains the select date range stuff */\n.datePickerHolder {\n  margin-top: 1rem;\n  padding-bottom: 1rem;\n  padding-left: 5px;\n}\n\n.datePickerHolder .datePickerHolderInner {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n/* Styling for select text */\n.datePickerHolder .selectText {\n  font-size: 16px;\n  font-weight: bold;\n  margin-right: 4rem;\n}\n\n/* Make the original bootstrap calendar icon/button transparent */\n.datePickerHolder .datePicker .md-datepicker-calendar-icon {\n  fill: rgba(0, 0, 0, 0);\n}\n\n/* Show a custom calendar icon and position it over the original bootstrap\n * calendar icon */\n/* Make it so we can position the .calendarIcon absolutely */\n.datePickerHolder .datePicker {\n  position: relative;\n}\n\n.datePickerHolder .datePicker .label {\n  color: #000;\n  display: inline-block;\n  font-size: 1.2rem;\n  position: relative;\n}\n\n.datePickerHolder .datePicker .md-datepicker-button.md-button.md-icon-button {\n  background: none;\n  display: none;\n  margin: 0;\n  padding-bottom: 16px;\n}\n/* Put the calendar icon over the original datepicker button */\n.datePickerHolder .datePicker .calendarIcon {\n  background: url('../../assets/images/icons/transcripts_calendar.svg');\n  width: 2rem;\n  height: 2rem;\n  background-size: contain;\n  display: inline-block;\n  position: relative;\n  top: 5px;\n}\n\n/* Style the border, width/height/padding on the datepicker box */\n.datePickerHolder .datePicker .md-datepicker-input-container {\n  border: 1px solid #808080;\n  width: 18rem;\n  padding-bottom: 0px;\n}\n\n.datePickerHolder\n  .datePicker\n  .md-datepicker-open\n  .md-datepicker-input-container {\n  border: none;\n}\n\n.datePickerHolder .datePicker .md-datepicker-input {\n  /* Make the 'Completed Before' / 'Completed After' text in the\n     * containers not get chopped off */\n  min-width: 150px;\n\n  padding-left: 5px;\n  padding-top: 3px;\n  color: #7f7f7f;\n}\n/* color the default text in the datepicker boxes */\n.datePickerHolder .datePicker .md-datepicker-input::-webkit-input-placeholder {\n  /* WebKit, Blink, Edge */\n  color: #7f7f7f;\n}\n.datePickerHolder .datePicker .md-datepicker-input:-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  color: #7f7f7f;\n  opacity: 1;\n}\n.datePickerHolder .datePicker .md-datepicker-input::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  color: #7f7f7f;\n  opacity: 1;\n}\n.datePickerHolder .datePicker .md-datepicker-input:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #7f7f7f;\n}\n\n/* Make the triangle on the right hand side of the datepicker box larger */\n.datePickerHolder .datePicker .md-datepicker-expand-triangle {\n  left: 20%;\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-top: 9px solid #b6b6b6;\n}\n\n/* Make the datepicker box close to the calendar icon */\n.datePickerHolder .md-datepicker-input-container {\n  margin-left: 0;\n}\n\n.moment-picker .decade-view td,\n.moment-picker .year-view td {\n  min-height: 8.4em;\n  min-width: 6.4285714286em;\n}\n\n.moment-picker .month-view td {\n  min-width: 3.4285714286em;\n}\n.moment-picker .day-view td,\n.moment-picker .hour-view td {\n  min-height: 2.3333333333em;\n  min-width: 3.4285714286em;\n}\n.moment-picker .minute-view td {\n  min-height: 1.8em;\n}\n\n.moment-picker .moment-picker-container {\n  min-width: 15em;\n  min-height: 15em;\n}\n\n.moment-picker th,\n.moment-picker td {\n  min-width: 4em;\n  min-height: 4em;\n}\n\n.moment-picker-input {\n  height: 30px;\n  min-width: 130px !important;\n  text-align: left;\n  font-size: 12px;\n  padding: 5px !important;\n}\n.moment-picker.inline {\n  position: absolute !important;\n}\n\n/*#endregion Angular Overrides*/\n\n/*#region CustomDatePicker*/\n.react-datepicker {\n  font:\n    normal 14px Calibri,\n    sans-serif;\n  border: 0.5px solid lightgray;\n  border-radius: 4px;\n}\n\n.react-datepicker-popper {\n  z-index: 300;\n}\n\n.react-datepicker-wrapper {\n  input {\n    font:\n      normal 14px Calibri,\n      sans-serif;\n    height: 27px;\n    border-radius: 4px;\n    border: 1px solid lightgray;\n    text-indent: 5px;\n\n    &.add-transcript-modal {\n      height: 36px;\n      width: 100%;\n      border: 0.5px solid black;\n    }\n  }\n  &.add-transcript-modal {\n    width: 100%;\n  }\n}\n\n.react-datepicker-wrapper,\n.add-transcript-modal {\n  > .react-datepicker__input-container {\n    width: 100%;\n  }\n}\n\n.react-datepicker__navigation-icon::before {\n  border: none;\n  position: relative;\n}\n\n.react-datepicker__navigation-icon {\n  width: 50px;\n  height: 25px;\n  top: -10px;\n}\n\n.react-datepicker-popper {\n  margin-top: 3px;\n}\n\n.react-datepicker__header {\n  button {\n    border: none;\n    background-color: transparent;\n    font:\n      bold 14px Calibri,\n      sans-serif;\n    cursor: pointer;\n  }\n}\n\n.react-datepicker__header--custom {\n  background-color: transparent;\n  border: none;\n  padding-bottom: 0px;\n}\n\n.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle {\n  fill: white;\n  color: white;\n  stroke: lightgray;\n}\n\n.react-datepicker__day-names {\n  font-weight: bold;\n  margin-top: 7px;\n\n  .react-datepicker__day-name {\n    width: 45px;\n    height: 25px;\n    margin: 0px;\n  }\n}\n\n.react-datepicker__day {\n  width: 45px;\n  height: 25px;\n  margin: 0px;\n  line-height: 25px;\n\n  &.react-datepicker__day--outside-month {\n    color: grey;\n  }\n}\n\n.react-datepicker__month {\n  margin: 5px 0px 5px 0px;\n}\n\n.custom-header {\n  display: flex;\n  padding-left: 10px;\n  padding-right: 10px;\n  align-items: center;\n  margin-bottom: 1px;\n\n  & button {\n    display: flex;\n    justify-content: center;\n    align-content: center;\n  }\n\n  .monthYear {\n    margin-bottom: 2px;\n    min-width: 17px;\n  }\n}\n\n.react-datepicker__year-wrapper {\n  justify-content: center;\n}\n.react-datepicker__year {\n  margin: 0px;\n  margin-bottom: 5px;\n  margin-top: -5px;\n}\n\n.react-datepicker__year .react-datepicker__year-text {\n  height: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.react-datepicker__month .react-datepicker__month-text {\n  height: 25px;\n  line-height: 25px;\n}\n\n.calendar-icon {\n  position: absolute;\n  top: 0;\n  right: 0;\n  background-color: #e3e3e3;\n  width: 34px;\n  height: 27px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0px 4px 4px 0px;\n  border: 1px solid lightgray;\n  pointer-events: none;\n\n  &.add-transcript-modal {\n    height: 36px;\n    width: 43px;\n    border: 0.5px solid black;\n  }\n\n  svg {\n    width: 16px;\n    height: 16px;\n    fill: #525354;\n\n    &.add-transcript-modal {\n      height: 20px;\n      width: 20px;\n    }\n  }\n}\n\n/*#endregion CustomDatePicker*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
